/* eslint-disable global-require */
import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth';

import router from './router';

axios.defaults.baseURL = (process.env.NODE_ENV === 'development' && !process.env.CORDOVA_PLATFORM)
  ? 'https://api-habit-tracker.claudiacanu.dev' : 'https://api-habit-tracker.claudiacanu.com';

window.axios = axios; // important for vue-tables-2

Vue.router = router; // important for vue-auth

Vue.use(VueAxios, axios);
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),

  loginData: {
    url: '/api/auth/login',
    method: 'POST',
    redirect: '/',
    fetchUser: false,
  },

  registerData: {
    url: '/api/auth/register',
    method: 'POST',
    redirect: '/',
    fetchUser: false,
  },

  logoutData: {
    url: '/api/auth/logout',
    method: 'GET',
    redirect: '/login',
    makeRequest: true,
  },

  refreshData: {
    url: '/api/auth/refresh',
    method: 'GET',
    enabled: false,
    interval: 30,
    error() {
      window.localStorage.clear();
      window.location = `${URL}login`;
    },
  },

  fetchData: {
    url: '/api/auth/user',
    method: 'GET',
    enabled: true,
  },

  // authRedirect: {
  //   path: '/dashboard',
  // },

  // forbiddenRedirect: {
  //   path: '/403',
  // },

  // notFoundRedirect: {
  //   path: '/404',
  // },

  // impersonateData: {
  //   url: '/api/auth/impersonate',
  //   method: 'POST',
  //   redirect: '/profile/view',
  // },

  // unimpersonateData: {
  //   url: '/api/auth/unimpersonate',
  //   method: 'POST',
  //   redirect: '/profile/view',
  //   makeRequest: false,
  // },

});
